import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactElement, ReactNode } from 'react';

import { tokens } from '../../../design';

/**
 * Shared layout primitives for the payout detail Обзор tab (AUT-128),
 * mirroring the orders `InfoBlocks` info-grid shapes from the mockup.
 * Kept page-local so the payouts page never imports across sibling
 * vertical boundaries (mirrors how reports keeps its own `displayName`).
 */

export const SectionTitle = ({ children }: { children: ReactNode }): ReactElement => (
  <Typography
    sx={{
      fontSize: 11,
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.6px',
      color: tokens.text.tertiary,
      mb: 1.25,
    }}
  >
    {children}
  </Typography>
);

export const InfoItem = ({
  label,
  children,
  span,
}: {
  label: string;
  children: ReactNode;
  /** When true, the item spans the full grid width. */
  span?: boolean;
}): ReactElement => (
  <Box sx={span ? { gridColumn: '1 / -1' } : undefined}>
    <Typography sx={{ fontSize: 11, color: tokens.text.tertiary, mb: 0.4 }}>{label}</Typography>
    <Box sx={{ fontSize: 14, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 0.75 }}>
      {children}
    </Box>
  </Box>
);

export const InfoGrid = ({ children }: { children: ReactNode }): ReactElement => (
  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px 24px' }}>{children}</Box>
);
